import React, { useState } from 'react';
import Login from './Login';
// import Registration from './Registration';
// import RegistrationStep2 from './RegistrationStep2';
import { useUser } from '../../auth/UseUser';
import Registration from './Registration';
import ForgotPassword from './ForgotPassword';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as PuskicaLogoSarena } from '../../assets/svg/PuskicaLogoSarena.svg';
import { ColoredText } from '../NavBar';
// import ForgotPassword from './ForgotPassword';
// import ResetPassword from './ResetPassword';
// import Intro from '../../assets/images/IntroImage.png';

function LoginScreen() {
    const {
        isSignedIn,
        user,
        setUser,
        setIsAdminApp,
        setTipEtiteta,
        setShowSelectedPuskica,
        setSelectedPuskica,
        setSelectedPitanja,
        setNavLista,
        setReturnedList,
    } = useUser();
    const [selectedMode, setSelectedMode] = useState('login');
    const [imgUrl, setImgUrl] = useState('');
    const navigate = useNavigate();

    const handleHomeButton = () => {
        navigate('/home');
        setShowSelectedPuskica(false);
        setSelectedPuskica(null);
        setSelectedPitanja([]);
        setIsAdminApp(false);
    };
    return (
        <div className="w-full bg-redError flex flex-row items-center h-[100vh] ">
            <div className="bg-white w-full lg:w-[50%] h-full overflow-auto orange-tiny-scroll md:orange-small-scroll">
                <div className="w-full flex flex-row items-center justify-center lg:justify-start gap-2 mt-4 lg:pl-[72px]">
                    <button className="text-gold text-[20px] font-bold" onClick={() => handleHomeButton()} title="Početna stranica">
                        <ColoredText text="PUŠKICA-KVIZ" fontSize={26} />
                    </button>
                </div>
                <div className="w-full pt-5">
                    {selectedMode === 'login' && <Login setSelectedMode={setSelectedMode} />}
                    {selectedMode === 'registration' && <Registration setSelectedMode={setSelectedMode} />}
                    {selectedMode === 'forgotPassword' && <ForgotPassword setSelectedMode={setSelectedMode} />}
                </div>
            </div>
            <div className="bg-blueDark w-[50%] hidden lg:flex items-center justify-center h-full">
                <PuskicaLogoSarena width={'60%'} height={'60%'} />
            </div>
        </div>
    );
}

export default LoginScreen;
